import axios from "axios";
import { API_ENDPOINTS } from "../../../helpers/config";

export const ProductService = {
  getProducts: async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + API_ENDPOINTS.PRODUCTS.GET_ALL
      );
      return response.data;
    } catch (err) {
      console.log(err);
    }
  },

  getCategories: async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + API_ENDPOINTS.CATEGORY.GET_ALL
      );
      return response.data;
    } catch (err) {
      console.log(err);
    }
  },

  createProduct: async (data: any) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + API_ENDPOINTS.PRODUCTS.CREATE_PRODUCT,
        data
      );
      return response;
    } catch (err) {
      console.log(err);
    }
  },

  deleteProduct: async (id: string) => {
    try {
      const response = await axios.delete(
        process.env.REACT_APP_API_URL +
          API_ENDPOINTS.PRODUCTS.DELETE_PRODUCT +
          id
      );
      return response;
    } catch (err) {
      console.log(err);
    }
  },
};
